import { useCallback } from 'react';
import { useCaseTabs as useSharedCaseTabs } from '@features/hooks/useCaseTabs';
import { useCaseTabsStore } from '@lp/core/store/caseTabs/case-tabs.store';
import { Case } from '@/api/apis/case';
import { setCaseItemQuery } from '@/queries/case';

export const useCaseTabs = () => {
  const handleBeforeNavigate = useCallback((caseId: string, caseInfo?: Case) => {
    if (caseInfo) {
      setCaseItemQuery(caseId, caseInfo);
    }
  }, []);

  return useSharedCaseTabs<Case>({
    store: useCaseTabsStore,
    onBeforeNavigate: handleBeforeNavigate,
    homeRoute: '/',
  });
};
